import React from 'react';
import DishIngredient from './DishIngredient';
import SimpleInput from '../form/SimpleInput';
import SVGClose from '../../svg/Close';

class DishSubcomponent extends React.Component {
  render() {
    const {
      subcomponent,
      componentIndex,
      index,
      deleteSubcomponent
    } = this.props;
    return (
      <div className="dish-subcomponent">
        {this.mapIngredients(subcomponent.ingredients)}
        <div className="dish-subcomponent__row">
          <div className="dish-subcomponent__instructions">
            <SimpleInput
              type="text"
              name="instructions"
              placeholder="Add instructions"
              value={subcomponent.instructions || ''}
              onChange={this.handleChange}
            />
          </div>
          <div className="dish-subcomponent__delete">
            <div
              className="dish__close-btn"
              onClick={() => deleteSubcomponent(componentIndex, index)}
            >
              <SVGClose />
            </div>
          </div>
        </div>
      </div>
    );
  }

  mapIngredients = ingredients => {
    const {
      index,
      updateIngredient,
      deleteIngredient,
      componentIndex
    } = this.props;
    if (ingredients) {
      return ingredients.map((ingredient, key) => (
        <DishIngredient
          key={key}
          componentIndex={componentIndex}
          subcomponentIndex={index}
          ingredientIndex={key}
          ingredient={ingredient}
          updateIngredient={updateIngredient}
          deleteIngredient={deleteIngredient}
        />
      ));
    }
  };

  handleChange = e => {
    const { componentIndex, index } = this.props;
    const { name, value } = e.target;
    const subcomponent = {
      ...this.props.subcomponent,
      [name]: value
    };
    // console.log(subcomponent);
    this.props.updateSubcomponent(componentIndex, index, subcomponent);
  };
}

export default DishSubcomponent;



// WEBPACK FOOTER //
// ./src/components/dish/DishSubcomponent.js